var quizQuestions = [
  {
    // Group 2
      question: "Do you have a hard time at work?",
      answers: [
          {
              type: "Michael",
              content: "That's what she said"
          },
          {
              type: "Meredith",
              content: "Only when I don't have a drink"
          },
          {
              type: "Dwight",
              content: "Never"
          },
          {
              type: "Jim",
              content: "I'd say the only hard thing at work is getting motivated to actually work"
          },
          {
              type: "Ryan",
              content: "Wait, work's supposed to be hard?"
          }
      ]
  },
  {
    // Group 1
      question: "What got you in trouble in high school?",
      answers: [
          {
              type: "Toby",
              content: "you didn't get in trouble"
          },
          {
              type: "Kevin",
              content: "eating in class"
          },
          {
              type: "Stanley",
              content: "sleeping"
          },
          {
              type: "Kelly",
              content: "talking"
          },
          {
              type: "Oscar",
              content: "arguing with teachers"
          }
      ]
  },
  {
    // Group 1
      question: "How will you probably die?",
      answers: [
          {
              type: "Stanley",
              content: "in your sleep"
          },
          {
              type: "Kevin",
              content: "sugar overdose"
          },
          {
              type: "Toby",
              content: "alone"
          },
          {
              type: "Kelly",
              content: "murdered"
          },
          {
            type: "Oscar",
            content: "exhaustion"
          }
      ]
  },
  {
    // Group 2
      question: "What is your dream occupation?",
      answers: [
        {
          type: "Dwight",
          content: "farmer"
        },
        {
            type: "Jim",
            content: "sports agent"
        },
        {
          type: "Michael",
          content: "comedian"
        },
        {
            type: "Meredith",
            content: "bar tender"
        },
        {
          type: "Ryan",
          content: "senior management"
        }
      ]
  },
  {
    // Group 2
      question: "What do you bring for the holiday gift-exchange?",
      answers: [
          {
              type: "Michael",
              content: "something expensive"
          },
          {
              type: "Dwight",
              content: "a last minute gift"
          },
          {
              type: "Ryan",
              content: "a re-gift from last year"
          },
          {
              type: "Jim",
              content: "something thoughtful and meaningful"
          },
          {
              type: "Meredith",
              content: "alcohol"
          }
      ]
  },
  {
    // Group 2
      question: "You have a crush on someone what do you do?",
      answers: [
          {
              type: "Michael",
              content: "force yourself on them, they’ll HAVE to love you"
          },
          {
              type: "Dwight",
              content: "boldly ask them out"
          },
          {
              type: "Ryan",
              content: "get your friends to set you up"
          },
          {
              type: "Jim",
              content: "secretly hope they notice you"
          },
          {
              type: "Meredith",
              content: "hit on them until it either works or fails horribly"
          }
      ]
  },
  {
    // Group 1
      question: "After work you...",
      answers: [
          {
              type: "Stanley",
              content: "Browse online personal ads"
          },
          {
              type: "Kevin",
              content: "Eat in front of the tv and watch a show"
          },
          {
              type: "Toby",
              content: "Read a good book"
          },
          {
              type: "Kelly",
              content: "Hit the bars and get the party started!"
          },
          {
            type: "Oscar",
            content: "Go to the gym to secretly meet someone"
          }
      ]
  },
  {
    // Group 1
      question: "If you were able to bring a book on a deserted island what would you bring?",
      answers: [
          {
              type: "Dwight",
              content: "Lord of The Rings"
          },
          {
              type: "Kevin",
              content: "Green Eggs & Ham"
          },
          {
              type: "Toby",
              content: "A detective novel"
          },
          {
              type: "Kelly",
              content: "Gossip magazines"
          },
          {
            type: "Oscar",
            content: "A romance novel"
          }
      ]
  },
  {
    // Group 2
      question: "What do you usually eat for lunch?",
      answers: [
          {
              type: "Michael",
              content: "you usually go to Chilli's or Benihana"
          },
          {
              type: "Stanley",
              content: "fast food drive-through"
          },
          {
              type: "Kevin",
              content: "something from the vending machine"
          },
          {
              type: "Jim",
              content: "brown bag"
          },
          {
              type: "Meredith",
              content: "anything I can find"
          }
      ]
  },
  {
    // Group 1
      question: "Your idea of a perfect Saturday is...",
      answers: [
          {
              type: "Toby",
              content: "No idea, something..."
          },
          {
              type: "Ryan",
              content: "Anything that doesn't involve me and work"
          },
          {
              type: "Stanley",
              content: "Whatever I feel like doing that day"
          },
          {
              type: "Kelly",
              content: "Going out to a club/bar"
          },
          {
              type: "Oscar",
              content: "Wine tasting in Napa Valley"
          }
      ]
  }
];

export default quizQuestions;



// WEBPACK FOOTER //
// ./src/api/quizQuestions.js